"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInstallationPanel = getInstallationPanel;

var _preact = require("preact");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _PanelItems = require("../PanelItems");

var InstallationPanelBody = function InstallationPanelBody(_ref) {
  var isInstalled = _ref.isInstalled,
      _onSave = _ref.onSave,
      _onCancel = _ref.onCancel,
      onApiKeyChangeCallback = _ref.onApiKeyChangeCallback,
      onApiKeyClickCallback = _ref.onApiKeyClickCallback,
      onSubdomainChangeCallback = _ref.onSubdomainChangeCallback,
      onSubdomainClickCallback = _ref.onSubdomainClickCallback,
      apiKey = _ref.apiKey,
      subdomain = _ref.subdomain,
      _onClickManage = _ref.onClickManage,
      _onClickUninstall = _ref.onClickUninstall,
      errorFields = _ref.errorFields,
      isSavingCredentials = _ref.isSavingCredentials;
  return (0, _preact.h)("div", {
    className: "panel-body-container installation__panel_body"
  }, (0, _preact.h)("div", {
    className: "panel-body-title"
  }, "To install Skilljar, you\u2019ll need"), (0, _preact.h)("div", {
    className: "panel-body-description"
  }, (0, _preact.h)("ul", {
    className: "panel-body-description-unordered-list"
  }, (0, _preact.h)("li", null, (0, _preact.h)("span", {
    className: "text--bold panel-body-description-label"
  }, "Admin permissions:"), (0, _preact.h)("span", {
    className: "panel-body-description-label-meta"
  }, ' ', "Admin permissions required to generate API key from Skilljar dashboard.")))), (0, _preact.h)("div", {
    className: "panel-form-input qa-form-subdomain"
  }, (0, _preact.h)("div", {
    className: "panel-form-input qa-form-subdomain"
  }, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    key: "subdomain",
    title: "Subdomain",
    meta: "This is the domain your courses are hosted on, e.g. courses.yoursite.com.",
    error: (0, _PanelItems.getErrorMessage)('subdomain', errorFields),
    required: true,
    showIconBeforeErrorMessage: true,
    qaClasses: "qa-subdomain-input",
    value: subdomain,
    disabled: isInstalled,
    onChangeCallback: function onChangeCallback(e) {
      return onSubdomainChangeCallback(e.target.value);
    },
    onClick: function onClick() {
      return onSubdomainClickCallback();
    }
  })), (0, _preact.h)("div", {
    className: "panel-form-input qa-form-api-key"
  }, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    key: "apiKey",
    title: "API key",
    meta: (0, _preact.h)("div", null, "You can generate an API key from", ' ', (0, _preact.h)("a", {
      href: "https://dashboard.skilljar.com/login?next=/settings/credentials/",
      className: "meta-link-input",
      rel: "noreferrer",
      target: "_blank"
    }, ' ', "API Credentials page"), ' ', "in Skilljar dashboard."),
    error: (0, _PanelItems.getErrorMessage)('apiKey', errorFields),
    required: true,
    showIconBeforeErrorMessage: true,
    qaClasses: "qa-api-key-input",
    value: apiKey,
    disabled: isInstalled,
    onChangeCallback: function onChangeCallback(e) {
      return onApiKeyChangeCallback(e.target.value);
    },
    onClick: function onClick() {
      return onApiKeyClickCallback();
    }
  })), isInstalled ? (0, _preact.h)(_PanelItems.ManageInstallationButtons, {
    onClickManage: function onClickManage() {
      return _onClickManage();
    },
    onClickUninstall: function onClickUninstall() {
      return _onClickUninstall();
    }
  }) : (0, _preact.h)(_PanelItems.ActionButtons, {
    onSave: function onSave() {
      return _onSave();
    },
    onCancel: function onCancel() {
      return _onCancel();
    },
    primaryButtonVariantType: "brand",
    primaryButtonText: "Install",
    isLoading: isSavingCredentials
  })));
};

function getInstallationPanel(props) {
  var isInstalled = props.isInstalled,
      _onSave2 = props.onSave,
      _onCancel2 = props.onCancel,
      _onApiKeyChangeCallback = props.onApiKeyChangeCallback,
      _onApiKeyClickCallback = props.onApiKeyClickCallback,
      _onSubdomainChangeCallback = props.onSubdomainChangeCallback,
      _onSubdomainClickCallback = props.onSubdomainClickCallback,
      _onClickManage2 = props.onClickManage,
      _onClickUninstall2 = props.onClickUninstall,
      apiKey = props.apiKey,
      subdomain = props.subdomain,
      errorFields = props.errorFields,
      hasUnsavedChanges = props.hasUnsavedChanges,
      isSavingCredentials = props.isSavingCredentials;
  return {
    body: (0, _preact.h)(InstallationPanelBody, {
      isInstalled: isInstalled,
      onSave: function onSave() {
        return _onSave2();
      },
      onCancel: function onCancel() {
        return _onCancel2();
      },
      onApiKeyChangeCallback: function onApiKeyChangeCallback(apiToken) {
        return _onApiKeyChangeCallback(apiToken);
      },
      onApiKeyClickCallback: function onApiKeyClickCallback() {
        return _onApiKeyClickCallback();
      },
      onSubdomainChangeCallback: function onSubdomainChangeCallback(subdomain) {
        return _onSubdomainChangeCallback(subdomain);
      },
      onSubdomainClickCallback: function onSubdomainClickCallback() {
        return _onSubdomainClickCallback();
      },
      onClickManage: function onClickManage() {
        return _onClickManage2();
      },
      onClickUninstall: function onClickUninstall() {
        return _onClickUninstall2();
      },
      apiKey: apiKey,
      subdomain: subdomain,
      errorFields: errorFields,
      isSavingCredentials: isSavingCredentials
    }),
    customClass: 'panel__body_without_header',
    hasUnsavedChanges: hasUnsavedChanges
  };
}